<template>
  <div class="row no-margin">
    <button
      v-if="!customerInfo"
      class="btn-customer col row no-margin"
      @click="setPosSection('customers')">
      <div class="col-10 text-left">
        {{ $t('message.nocustomerselected') }}
      </div>
      <div class="col-2 text-right"><i class="fas fa-angle-right"/></div>
    </button>
    <button
      v-else
      class="btn-customer col row no-margin"
      @click="setPosSection('customers')">
      <div class="col-10 text-left selected text-success">
        <i
          class="fas fa-check"
          style="margin-right: 3px;"/>
        {{ customerInfo.customer_name }}
      </div>
      <div class="col-2 text-right"><i class="fas fa-angle-right"/></div>
    </button>
  </div>
</template>

<script>
import customerButtonMixin from '@/mixins/pos/customerButton'

export default {
  mixins: [customerButtonMixin],
}
</script>

<style scoped>
  button.btn-customer {
    border-top: none;
    border-bottom: solid 1px #F2F2F2;
    border-left: none;
    border-right: none;
    background: #FFF;
    color: #6C7A86;
    font-size: 14px;
    padding: 14px 0 12px 0;
    outline: none;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/common/CustomerButton.vue